
import { Command } from 'commander'
import { disablePlugin, downloadAndEnablePlugin, updatePlugin, publishPlugin } from '../ops/plugin'

export function addPluginCommands(program: Command): void {

  const subProgram = program.command('plugin')

  subProgram.command('enable')
    .argument('<plugin>', 'The plugin that need to be enabled')
    .action(downloadAndEnablePlugin)

  subProgram.command('disable')
    .argument('<plugin>', 'The plugin that need to be disabled')
    .action(disablePlugin)

  subProgram.command('update')
    .argument('<plugin>', 'Update the plugin to latest or specified version')
    .option("-v, --version [version]", 'The version of the plugin')
    .action(updatePlugin)

  subProgram.command('publish').action(publishPlugin)
}